<cdk-virtual-scroll-viewport
  [itemSize]="dayColumnWidth"
  [maxBufferPx]="dayColumnWidth * 1.75"
  [minBufferPx]="dayColumnWidth * 1.5"
  class="inquiry-scrollable-days"
  orientation="horizontal"
  baseInquiryHorizontalScroll
>
  <div
    *cdkVirtualFor="let dateItem of similarInquiriesDays; let i = index; trackBy: trackByDay"
    [ngClass]="{
      'calendar-weekend': dateItem.isWeekend,
      today: dateItem.isToday
    }"
    class="day-container"
  >
    <div
      *ngFor="let shiftItem of dateItem.bubbles; trackBy: trackByBubble"
      class="calendar-column"
    >
      <base-customer-shift-plan-bubble
        [bubble]="shiftItem"
        [isCalendar]="false"
      ></base-customer-shift-plan-bubble>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
